import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { App } from './App';
import { reportWebVitals } from './reportWebVitals';
import { sendToVercelAnalytics } from './vitals';
import { BrowserRouter, Route, Routes } from 'react-router';
import { MentionsLegales as LegalPage } from './legal/MentionsLegales';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/mentions-legales" element={<LegalPage />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals(sendToVercelAnalytics);
